import { Component, Inject, OnInit } from '@angular/core';
import { Document } from '../../../models/document';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-document-modal',
    templateUrl: './document-modal.component.html',
    styleUrls: ['./document-modal.component.scss'],
    standalone: true
})
export class DocumentModalComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public document: Document, private sanitizer: DomSanitizer) {
    }

    ngOnInit(): void {
    }

    url(): SafeResourceUrl {
        const url = this.sanitizer.bypassSecurityTrustResourceUrl(this.document.url);
        return url;
    }

}
